<template>
  <v-container fluid class="py-4 px-0">
    <template v-if="rooms && rooms.asPM.length > 0">
      <ProjectsTable
        :projects="rooms.asPM"
        :pagination="pmPagination"
        :total="rooms.asPM.length"
        :hidePagination="hidePagination"
        :isPending="pmRoomsPending"
        @update:current-page="emitPageChange('pm', $event)"
        @update:page-size="emitPageSizeChange('pm', $event)"
        @sort="emitSorting('pm', $event)"
      />
    </template>
    <template v-if="rooms && rooms.asGuest.length > 0">
      <v-row v-if="rooms.asPM.length > 0">
        <v-col>
          <!-- We want to share the same style and margins as the pm subtitle from the projectheader component   -->
          <div class="text-grey-800 font-weight-semi-bold text--medium my-7">
            {{ $t('projects.ProjectsTableTemplate.guest', { projectsCount: rooms.asGuest.length }) }}
          </div>
        </v-col>
      </v-row>
      <ProjectsTable
        :projects="rooms.asGuest"
        :pagination="guestPagination"
        :total="rooms.asGuest.length"
        :hidePagination="hidePagination"
        :isPending="guestRoomsPending"
        hide-members
        @update:current-page="emitPageChange('guest', $event)"
        @update:page-size="emitPageSizeChange('guest', $event)"
        @sort="emitSorting('guest', $event)"
      />
    </template>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'

import ProjectsTable from './table/ProjectsTable.vue'

export default {
  name: 'ProjectsTableTemplate',
  components: { ProjectsTable },
  props: {
    rooms: {
      required: true,
      validator: (item) => typeof item === 'object' || item === null,
    },
    hidePagination: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState('rooms', ['pmPagination', 'guestPagination', 'pmRoomsPending', 'guestRoomsPending']),
  },
  methods: {
    emitPageChange(role, page) {
      this.$emit('update:page', { role, page })
    },
    emitPageSizeChange(role, pageSize) {
      this.$emit('update:page-size', { role, pageSize })
    },
    emitSorting(role, payload) {
      this.$emit('sort', { role, sorting: payload })
    },
  },
}
</script>
